// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#ol-modal {
  background: #010101cc;
  width: 100vw;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 2147483646;
}

#ol-modal-container {
  position: relative;
  width: 100%;
  height: 100%;
  border-width: 0;
  margin: auto;
  display: block;
  max-width: 768px;
  background: #ffffff;
}

#ol-closeModal {
  position: absolute;
  top: 7px;
  right: calc(50% - min(384px, 50%) + 16px);
  font-size: 20px;
  height: 35px;
  width: 45px;
  padding: 0;
  cursor: pointer;
  background: none;
  border: none;
}

#ol-closeModal:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 2px;
  box-shadow: 0 0 0 5px #000000;
}

.ol-focus-sentinel {
  position: fixed;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/modal/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yCAAyC;EACzC,eAAe;EACf,YAAY;EACZ,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["#ol-modal {\n  background: #010101cc;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: fixed;\n  z-index: 2147483646;\n}\n\n#ol-modal-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-width: 0;\n  margin: auto;\n  display: block;\n  max-width: 768px;\n  background: #ffffff;\n}\n\n#ol-closeModal {\n  position: absolute;\n  top: 7px;\n  right: calc(50% - min(384px, 50%) + 16px);\n  font-size: 20px;\n  height: 35px;\n  width: 45px;\n  padding: 0;\n  cursor: pointer;\n  background: none;\n  border: none;\n}\n\n#ol-closeModal:focus-visible {\n  outline: 2px solid #ffffff;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 5px #000000;\n}\n\n.ol-focus-sentinel {\n  position: fixed;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
